import * as types from '../constants/actionTypes';

export function approveTimesheet({timesheetID, status, data} = {}) {
    return { type: types.APPROVE_TIMESHEET, timesheetID, status, data };
}
export function cmlmLoadTimesheetsByWeek({week, status, data} = {}) {
    return { type: types.CM_LM_LOAD_TIMESHEETS_BY_WEEK, week, status, data };
}
export function deleteTimesheet({timesheetID, status, data} = {}) {
    return { type: types.DELETE_TIMESHEET, timesheetID, status, data };
}
export function editTimesheetStatus({timesheetID, timesheetStatus, status, data} = {}) {
    return { type: types.EDIT_TIMESHEET_STATUS, timesheetID, timesheetStatus, status, data };
}
export function loadTimesheetsByUserAndWeek({user, week, status, data} = {}) {
    return { type: types.LOAD_TIMESHEETS_BY_USER_AND_WEEK, user, week, status, data };
}
export function loadTimesheetsByWeek({week, status, data} = {}) {
    return { type: types.LOAD_TIMESHEETS_BY_WEEK, week, status, data };
}
export function pmoLoadTimesheetsByYear({year, status, data} = {}) {
    return { type: types.PMO_LOAD_TIMESHEETS_BY_YEAR, year, status, data };
}
export function pmoLoadTimesheetsByRange({year, part, status, data} = {}) {
    return { type: types.PMO_LOAD_TIMESHEETS_BY_RANGE, year, part, status, data };
}
export function rejectApprovedHours({timesheetID, approvedHoursID, message, status, data} = {}) {
    return { type: types.REJECT_APPROVED_HOURS, timesheetID, approvedHoursID, message, status, data };
}
export function setLoadingFlagForTimesheetState() {
    return { type: types.SET_LOADING_FLAG_FOR_TIMESHEET_STATE };
}
export function setTimesheetStatusToEntry({timesheetID, status, data} = {}) {
    return { type: types.SET_TIMESHEET_STATUS_TO_ENTRY, timesheetID, status, data };
}
export function submitTimesheet({timesheetID, status, data} = {}) {
    return { type: types.SUBMIT_TIMESHEET, timesheetID, status, data };
}


/** WEBPACK FOOTER **
 ** ./src/app/constants/timesheetActions.js
 **/